/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

import AdminApp from './admin/App';
import PosApp from './pos/App';
import * as Sentry from '@sentry/react';

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import React from 'react';
import { createRoot } from 'react-dom/client';

if (document.getElementById('app')) {
    Sentry.init({
        dsn: 'https://32a688819740c524c42404b14a5292bc@o64802.ingest.us.sentry.io/4509446544621568',
        sendDefaultPii: true,
        environment: window.IS_PRODUCTION ? 'production' : 'stage',
    });

    const Index = createRoot(document.getElementById('app'));
    const App = window.shopify.environment.pos ? PosApp() : AdminApp();

    Index.render(React.createElement(App));
}
